import { render, staticRenderFns } from "./SubscriptionsDetail.vue?vue&type=template&id=020b9de4"
import script from "./SubscriptionsDetail.vue?vue&type=script&lang=js"
export * from "./SubscriptionsDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports